import React from 'react';
import { Box } from '@mui/system';
import STERISImage from '../../styles/img/sterisImage.png';


const NoRoutes = (props) => {
		return <Box sx={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
			<img src={STERISImage} alt="No Dashboard" />
		</Box>
	
};
export default NoRoutes;